module.exports = __webpack_public_path__ + "img/question-circle.f93026c7.svg";